import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const ViewReports = lazyWithRetry(
  () => import("./ui/ViewReports"),
  "ViewReports",
);
const SelectPlantPage = lazyWithRetry(
  () => import("@features/plantas/ui/pages/SelectPlantPage"),
  "SelectPlantPage",
);
const ScannerReportsPage = lazyWithRetry(
  () => import("./ui/pages/ScannerReportsPage"),
  "ScannerReportsPage",
);

export const REPORTS_ALLOWED_ROLES = [1, 2, 3, 5, 7];

/**
 * Rutas de reportes
 */
const reportsRoutes = buildRoutes([
  // Ruta unificada de reportes
  {
    path: "/reportes",
    element: ViewReports,
    roles: REPORTS_ALLOWED_ROLES,
  },

  // Reportes con escáner
  {
    path: "/reportes/scanner",
    element: ScannerReportsPage,
    roles: REPORTS_ALLOWED_ROLES,
  },

  // Rutas de admin
  {
    path: "/admin/reports",
    element: SelectPlantPage,
    roles: [1, 2, 5, 7],
  },
  {
    path: "/admin/reports/:planta",
    element: ViewReports,
    roles: [1, 2, 5, 7],
  },
  {
    path: "/admin/reports-old/:planta",
    element: ViewReports,
    roles: [1, 2, 5, 7],
    key: "admin-reports-old",
  },

  // Rutas de inspector
  {
    path: "/inspector/reports",
    element: ViewReports,
    roles: [2, 5],
  },
  {
    path: "/inspector/reports-old",
    element: ViewReports,
    roles: [2, 5],
    key: "inspector-reports-old",
  },
]);

export default reportsRoutes;
